import React from "react";
export default function Loader(props) {
  return (
    <>
      <div className="outer-loading-dots">
        <div className="loading-dots">
          <p className="wait-text">
            {props.message ? props.message : "Please wait"}
          </p>
          <span>
            <i></i>
            <i></i>
            <i></i>
            <i></i>
          </span>
        </div>
      </div>
    </>
  );
}